import React, { useEffect } from 'react';
import styles from './Profile.module.css';
import useWalletStore from '../../providers/walletStore';
import { useSupabaseStore } from '../../providers/supabaseStore';
import solanaLogo from '../Buttons/assets/solanaLogoMark.png';

const WalletIcon = () => (
  <svg 
    viewBox="0 0 512 512" 
    width="24" 
    height="24" 
    fill="white"
  >
    <path d="m415.5 128h-255.5c-17 0-18.8-20.6-4.4-24h259.9c3.7 0 7.5.2 11.2.7-5.1-36.1-38.6-61.2-74.6-56-1 .1-1.9.3-2.9.5l-252.9 43.1c-3.4.5-6.9 1.1-10.3 1.8h-.2c-1.3.2-2.5.5-3.8.8-38.7 9.3-50 44.1-50 65.1v24.2c-.3 2.6-.5 5.2-.5 7.8v192c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64v-192c0-35.3-28.7-64-64-64zm-47.5 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"/>
  </svg>
);

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const Profile = ({ onClose }) => {
  const { wallet, disconnectWallet } = useWalletStore();
  const { points, fetchPoints } = useSupabaseStore();

  useEffect(() => {
    if (wallet?.address) {
      fetchPoints(wallet.address);
    }
  }, [wallet?.address, fetchPoints]);

  const handleLogout = async () => {
    await disconnectWallet();
    onClose();
  };

  // Get the first 6 characters of the full wallet address
  const walletPrefix = wallet?.address?.slice(0, 6) || '';

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.dropdown} onClick={e => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.walletInfo}>
            <div className={styles.iconWrapper}>
              <WalletIcon />
            </div>
            <div className={styles.walletDetails}>
              <span className={styles.walletLabel}>{walletPrefix}</span>
              <span className={styles.walletAddress}>{wallet?.shortAddress}</span>
            </div>
          </div>
          <div className={styles.actionGroup}>
            <div className={styles.networkBadge}>
              <img 
                src={solanaLogo}
                alt="Solana"
                className={styles.networkIcon}
              />
              <span>Solana</span>
            </div>
            <button className={styles.closeButton} onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
        </div>

        <div className={styles.balanceSection}>
          <div className={styles.balanceLabel}>Total Earning:</div>
          <div className={styles.balanceAmount}>
            {points || 0} pts
          </div>
        </div>

        <button className={styles.logoutButton} onClick={handleLogout}>
          Log Out
        </button>
      </div>
    </div>
  );
};

export default Profile;
